import React from "react";
import { Form } from "react-bootstrap";
import RevShareModal from "../../common/overrides/RevShareModal";
import { UPDATE_HOUR_UTILIZATION_REQUEST_SUCCESS } from "../../../redux/actions/ActionTypes";
import FormRow from "../../common/forms/FormRow";
import PlainTextField from "../../common/forms/PlainTextField";
import NumericInput from "../../common/forms/NumericInput";

class EditRequestModal extends React.Component {
  render() {
    return (
      <RevShareModal
        api={UPDATE_HOUR_UTILIZATION_REQUEST_SUCCESS}
        buttonText="Edit"
        title="Update Request"
        yesButtonOnClick={this.submitUtilizationRequestUpdate}
        yesButtonClicked={this.state.clickedSubmit}
      >
        <Form noValidate ref={(element) => (this.form = element)} validated={this.state.validated}>
          <FormRow
            columns={[
              <PlainTextField inline label="Hours Available" value={this.props.request.requestableHours} />,
              <PlainTextField inline label="Rate" value={this.props.request.rate} />,
            ]}
          />
          <FormRow
            columns={[
              <PlainTextField label="Current Hours" value={this.props.request.hours} />,
              <NumericInput
                label="Hours"
                onChange={this.onHoursChange}
                ref={(element) => (this.hoursField = element)}
                value={0.0}
              />,
            ]}
          />
          <FormRow
            columns={[
              <PlainTextField
                inline
                label="Current Total Requested"
                value={"$" + (this.props.request.rateValue * this.props.request.hours).toFixed(2)}
              />,
              <PlainTextField
                inline
                label="New Total Requested"
                ref={(element) => (this.totalValueField = element)}
                value="$0.00"
              />,
            ]}
          />
        </Form>
      </RevShareModal>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      validated: false,
      updatedRequest: {
        hours: this.props.request.hours,
        utilizationType: this.props.request.utilizationTypeId,
      },
      clickedSubmit: false,
    };

    this.onUtilizationTypeChange = this.onUtilizationTypeChange.bind(this);
    this.onHoursChange = this.onHoursChange.bind(this);
    this.formIsValid = this.formIsValid.bind(this);
    this.submitUtilizationRequestUpdate = this.submitUtilizationRequestUpdate.bind(this);
  }

  onUtilizationTypeChange() {
    let request = { ...this.state.updatedRequest };
    request.utilizationType = this.typePicker.value;
    this.setState({ updatedRequest: request });
  }

  onHoursChange() {
    let newRequest = { ...this.state.updatedRequest };
    newRequest.hours = parseFloat(this.hoursField.value);
    this.setState({ updatedRequest: newRequest });
    const total = newRequest.hours * this.props.request.rateValue;
    this.totalValueField.value = isNaN(total) ? "$0.00" : "$" + total.toFixed(2);
  }

  formIsValid() {
    const errors = {
      utilizationTypeError: "You must select a utilization type.",
      hoursExceedMinError: "you must request more than 0 hours to be utilized.",
      hoursExceedMaxError: "You cannot request more hours than you have availible.",
    };
    let isValid = true;
    let alert = "The following error(s) exist in the form:";

    if (this.state.updatedRequest.hours < 0.25) {
      alert = alert + "\n\t" + errors.hoursExceedMinError;
      isValid = false;
    }
    if (this.state.updatedRequest.hours > this.props.requestableHours) {
      alert = alert + "\n\t" + errors.hoursExceedMaxError;
      isValid = false;
    }

    if (!isValid) {
      window.alert(alert);
    }

    return isValid;
  }

  submitUtilizationRequestUpdate(event) {
    if (!this.formIsValid()) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      this.setState({ validated: true, clickedSubmit: true });
      return this.props.update(this.props.request.id, this.state.updatedRequest);
    }
  }
}

export default EditRequestModal;
